import React, { useEffect, useState } from 'react';
import { 
    Box, 
    Flex, 
    Icon,
    Text, 
    Link,
    Button
} from '@chakra-ui/react';
import { HomeProps } from "../../types";
import { LinkContext } from '../../LinkContext';
import { ReactComponent as LeftArrow } from "../../img/leftArrow.svg";

const Header: React.FC<HomeProps> = ({ olympInfo }) => {
    return(
        <Box 
            w='100%' 
            px={{
                base: '24px', 
                xl: '100px'
            }}
            pb='30px'
            pt='50px'
            bg='#1D438A'
        >
            <LinkContext.Consumer>
                {(APP_LINK) => (
                    <Box className='topgap'
                        fontSize={{
                            base: '14px',
                            xl: '18px'
                        }}
                    >
                        <Link href={APP_LINK}>
                            <Icon as={LeftArrow} />
                        </Link>
                        <Box pb='15px'>
                            <Text 
                                as='b'
                                color='white' 
                                fontSize={{
                                    base: '24px',
                                    xl: '41px'
                                }}
                                lineHeight={{
                                    base: '29px',
                                    xl: '49px'
                                }}
                            >
                                {olympInfo.name}
                            </Text>
                        </Box>
                        <Box
                            py='20px'
                            borderY='2px dashed white'
                        >
                            <Text 
                                color='white'
                                w={{
                                    base: '100%',
                                    xl: '50%'
                                }} 
                                fontSize={{
                                    base: '14px',
                                    xl: '18px'
                                }}
                                lineHeight={{
                                    base: '18px',
                                    xl: '23px'
                                }}
                            >
                                {olympInfo.description}
                            </Text>
                        </Box>
                        <Button
                            w={{
                                base: '100%',
                                xl: '415px'
                            }}
                            mt='20px'
                            bg='#E48F0D'
                            color='white'
                            _hover={{ bg: 'orange.500' }}
                            fontSize={{
                                base: '14px',
                                xl: '16px'
                            }}
                            lineHeight={{
                                base: '17px',
                                xl: '20px'
                            }}
                            onClick={() => window.open(olympInfo.website_link, '_blank')}
                        >
                            Перейти на страницу олимпиады
                        </Button>
                    </Box>
                )}
            </LinkContext.Consumer>
        </Box>
    )
}

export default Header;